(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  else root.FafBedroomCore = api;
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  "use strict";
  var strings = {
    eyebrow: "Made for your room",
    heading: "Build your {family} bedroom",
    intro: "Start with your bed. Add the matching pieces you love, in the quantities you need.",
    presets: "Start with a combination",
    optional: "Optional",
    none: "None — bed only",
    notAdded: "Not added",
    noneGroup: "No {group}",
    unavailable: "Unavailable",
    quantity: "Quantity per bedroom",
    details: "See details",
    dimensions: "Dimensions",
    dimensionsUnknown: "See product details for dimensions.",
    productDetails: "View full product details",
    selected: "Selected",
    each: "each",
    summary: "Your bedroom",
    subtotal: "Your total",
    rooms: "Number of bedrooms",
    multiply: "Your quantities below include {count} bedrooms.",
    single: "Quantities shown are for one bedroom.",
    taxNote: "Taxes and delivery calculated at checkout.",
    supportRequired: "This bed needs a suitable foundation or box spring, sold separately.",
    supportIncluded: "Mattress support is included with this bed.",
    supportUnknown: "Confirm the mattress support requirements for this bed before ordering.",
    optionsLoading: "Loading matching pieces…",
    optionsUnavailable: "Some matching pieces could not be loaded. Refresh availability to try again.",
    selectionAdjusted: "{items} could not be matched to your new bed selection and were removed. Your other selections are saved.",
    finishUnavailable: "Not offered for this bed selection",
    presetUnavailable: "This combination is not available for the selected bed.",
    preflightFailed: "We could not verify current pricing and availability for every selected item and matching package. Nothing was submitted. Please try again.",
    sizeUnavailable: "Not offered in {size}",
    mattressCleared: "Your previous mattress selection is not offered in {size}, so it was removed. Your matching furniture selections are saved.",
    savings: "Save {amount} with the matching package price",
    packageNote: "We apply the lower matching package price for these exact selections. Your cart will list the package and any extra pieces.",
    includes: "Includes",
    packageContents: "Matching package includes: {items}",
    remaining: "Extra pieces are listed separately in your cart.",
    add: "Add selected items to cart",
    bedOnly: "Add bed to cart",
    adding: "Adding your bedroom…",
    checking: "Checking your selections…",
    added: "Your selected bedroom furniture has been added to your cart.",
    reviewCart: "Review cart",
    reviewReset: "I have reviewed my cart — start a new selection",
    reviewFirst: "Please review your cart before starting another selection.",
    refresh: "Refresh availability",
    refreshFailed: "We could not refresh availability. Your selection is saved. Please try again.",
    updated: "Pricing or availability has changed. Review your updated selection, then add it to your cart.",
    optionError: "{item} cannot be added right now. Choose another option or remove it.",
    identityError: "We cannot verify {item} right now. Refresh availability or choose another option.",
    invalidQuantity: "Choose a valid quantity for {item}.",
    bedUnavailable: "Choose an available bed size above before adding your bedroom.",
    bedLoading: "Please wait for your selected bed options to finish updating.",
    upsellPending: "Please wait for your other add-on to finish updating the cart.",
    cartReadFailed: "We could not check your cart. Nothing was submitted. Please try again.",
    uncertain: "We could not confirm every selected item. Review your cart before adding anything again; some items may already be there.",
    partial: "Only part of your bedroom addition was confirmed. Review your cart before adding anything again.",
    rejected: "Your selection could not be added. {message}",
    drawerFailed: "Your furniture was added. Open your cart to review the complete selection.",
    savedAttempt: "A previous bedroom addition needs review. Check your cart before starting another selection.",
    blocked: "Review your cart before adding again",
    unexpected: "We could not prepare this bedroom combination. Your bed is still available through the regular purchase options."
  };
  function id(value) { return value == null ? "" : String(value); }
  function integer(value) { return typeof value === "number" && Number.isSafeInteger(value); }
  function price(value) { return integer(value) && value >= 0; }
  function identify(products, spec) {
    if (!spec) return null;
    var product = products && products[spec.productHandle];
    if (!product || id(product.id) !== id(spec.productId) || product.handle !== spec.productHandle || !Array.isArray(product.variants)) return null;
    var variant = product.variants.find(function (entry) { return id(entry.id) === id(spec.variantId); });
    if (!variant || variant.sku !== spec.sku || typeof variant.available !== "boolean" || !price(variant.price)) return null;
    if (spec.expectedOptions != null) {
      if (!Array.isArray(spec.expectedOptions) || !spec.expectedOptions.every(function (expected) {
        if (!expected || typeof expected.name !== "string" || typeof expected.value !== "string") return false;
        var index = (product.options || []).findIndex(function (option) { return (typeof option === "string" ? option : option && option.name) === expected.name; });
        return index >= 0 && (variant.options && variant.options[index] != null ? variant.options[index] : variant["option" + (index + 1)]) === expected.value;
      })) return null;
    }
    if (spec.size) {
      var sizeIndex = (product.options || []).findIndex(function (option) { return /(^|\s)size$/i.test(typeof option === "string" ? option : option.name || ""); });
      var sizeValue = sizeIndex >= 0 ? (variant.options && variant.options[sizeIndex] || variant["option" + (sizeIndex + 1)]) : null;
      if (sizeValue !== spec.size) return null;
    }
    return { product: product, variant: variant, available: variant.available, price: variant.price };
  }
  function resolveOption(option, size, bedVariantId) {
    if (!option) return null;
    if (option.variantsByBedVariant) {
      var context = option.variantsByBedVariant[id(bedVariantId)];
      if (!context) return null;
      option = Object.assign({}, option, context);
    }
    if (!option.variantsByBedSize) return option;
    var spec = option.variantsByBedSize[size];
    return spec && spec.size === size ? Object.assign({}, option, spec) : null;
  }
  function presetSelection(preset, bedVariantId) {
    if (!preset) return null;
    return preset.selectionsByBedVariant ? preset.selectionsByBedVariant[id(bedVariantId)] || null : preset.selection || null;
  }
  function eligiblePackages(family, bedVariantId, selection) {
    return (family.packageMatches || []).filter(function (pack) {
      if (id(pack.bedVariantId) !== id(bedVariantId) || pack.cartQuantity !== 1 || !pack.structuralPartsAlreadyIncluded) return false;
      return Object.keys(pack.selection || {}).every(function (key) {
        var need = pack.selection[key], have = selection && selection[key];
        return !need || (have && have.optionKey === need.optionKey && integer(need.quantity) && need.quantity > 0 && have.quantity >= need.quantity);
      });
    });
  }
  function productHandles(family, bedVariantId, selection, selectedOnly, sellingPlan) {
    var bed = family && (family.bedVariants || []).find(function (entry) { return id(entry.variantId) === id(bedVariantId); });
    if (!bed) return [];
    var handles = [family.bedHandle];
    (family.groups || []).forEach(function (group) {
      (group.options || []).forEach(function (option) {
        var chosen = selection && selection[group.key];
        if (selectedOnly && (!chosen || chosen.quantity <= 0 || chosen.optionKey !== option.key)) return;
        var resolved = resolveOption(option, bed.size, bed.variantId);
        if (resolved && resolved.productHandle) handles.push(resolved.productHandle);
      });
    });
    var packages = selectedOnly ? eligiblePackages(family, bedVariantId, selection) : (family.packageMatches || []).filter(function (pack) { return id(pack.bedVariantId) === id(bedVariantId); });
    if (!sellingPlan) packages.forEach(function (pack) { if (pack.productHandle) handles.push(pack.productHandle); });
    return Array.from(new Set(handles));
  }
  function validQuantity(variant, quantity) {
    if (!integer(quantity) || quantity < 1) return false;
    var rule = variant.quantity_rule || {};
    var min = Number(rule.min || 1);
    var step = Number(rule.increment || 1);
    var max = rule.max == null ? null : Number(rule.max);
    return quantity >= min && (max == null || quantity <= max) && quantity % step === 0;
  }
  function cloneSelection(selection) {
    var copy = {};
    Object.keys(selection || {}).forEach(function (key) {
      var value = selection[key];
      copy[key] = value ? { optionKey: value.optionKey, quantity: value.quantity } : null;
    });
    return copy;
  }
  function properties(value) {
    var result = {};
    Object.keys(value || {}).sort().forEach(function (key) {
      if (value[key] != null && String(value[key]) !== "") result[key] = String(value[key]);
    });
    return result;
  }
  function lineKey(line) {
    var plan = line.selling_plan || line.selling_plan_allocation && line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.id;
    return id(line.variant_id || line.id) + "|" + id(plan) + "|" + JSON.stringify(properties(line.properties));
  }
  function cartCounts(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var result = {};
    for (var i = 0; i < cart.items.length; i += 1) {
      var line = cart.items[i];
      if (!integer(line.quantity) || line.quantity < 0 || !id(line.variant_id || line.id)) return null;
      var key = lineKey(line);
      result[key] = (result[key] || 0) + line.quantity;
    }
    return result;
  }
  function reconcile(before, after, items) {
    var initial = cartCounts(before), current = cartCounts(after), wanted = cartCounts({ items: items });
    if (!initial || !current || !wanted) return { status: "ambiguous" };
    var keys = Array.from(new Set(Object.keys(initial).concat(Object.keys(current), Object.keys(wanted))));
    var confirmed = true, unchanged = true, matched = false, unexpected = false;
    keys.forEach(function (key) {
      var delta = (current[key] || 0) - (initial[key] || 0);
      var expected = wanted[key] || 0;
      if (delta !== expected) confirmed = false;
      if (delta !== 0) unchanged = false;
      if (expected > 0 && delta > 0 && delta <= expected) matched = true;
      if (delta < 0 || delta > expected || (expected === 0 && delta !== 0)) unexpected = true;
    });
    return { status: confirmed ? "confirmed" : unchanged ? "unchanged" : matched && !unexpected ? "partial" : "ambiguous" };
  }
  function compute(input) {
    var family = input.family, products = input.products || {}, selection = input.selection || {};
    var bedrooms = input.bedrooms == null ? 1 : input.bedrooms;
    var errors = [], contents = [], selected = [], normalized = {}, candidates = [];
    var hasExtras = Object.keys(selection).some(function (key) { return selection[key] && Number(selection[key].quantity) > 0; });
    var result = { ok: false, errors: errors, hasExtras: hasExtras, selection: normalized, contents: contents, items: [], total: null, standaloneTotal: null, savings: 0, packageMatch: null, bedrooms: bedrooms, bed: null };
    if (!family || !Array.isArray(family.groups) || !Array.isArray(family.bedVariants)) {
      errors.push({ code: "config", label: "bedroom" }); return result;
    }
    if (!integer(bedrooms) || bedrooms < 1 || bedrooms > 99) errors.push({ code: "quantity", label: "bedrooms" });
    var bedSpec = family.bedVariants.find(function (entry) { return id(entry.variantId) === id(input.bedVariantId); });
    var bedIdentity = bedSpec && identify(products, { productHandle: family.bedHandle, productId: family.bedProductId, variantId: bedSpec.variantId, sku: bedSpec.sku, expectedOptions: bedSpec.expectedOptions });
    if (!bedIdentity) errors.push({ code: "bed_identity", label: family.label + " bed" });
    if (errors.length) return result;
    var bed = { id: id(bedSpec.variantId), label: family.label + " " + bedSpec.size + " bed" + (bedSpec.finishLabel ? " — " + bedSpec.finishLabel : ""), quantity: bedrooms, unitPrice: bedIdentity.price, price: bedIdentity.price * bedrooms, spec: bedSpec, product: bedIdentity.product, variant: bedIdentity.variant, available: bedIdentity.available };
    result.bed = bed;
    contents.push(bed);
    Object.keys(selection).forEach(function (key) {
      if (selection[key] && !family.groups.some(function (group) { return group.key === key; })) errors.push({ code: "option", label: key });
    });
    family.groups.forEach(function (group) {
      var choice = selection[group.key];
      normalized[group.key] = null;
      if (!choice || choice.quantity === 0) return;
      var rawOption = group.options.find(function (entry) { return entry.key === choice.optionKey; });
      var option = resolveOption(rawOption, bedSpec.size, bedSpec.variantId);
      if (!option) { errors.push({ code: "option", label: group.label, group: group.key }); return; }
      if (!integer(choice.quantity) || choice.quantity <= 0 || !group.quantities.includes(choice.quantity)) { errors.push({ code: "quantity", label: group.label, group: group.key }); return; }
      var found = identify(products, option);
      if (!found) { errors.push({ code: "identity", label: option.label, group: group.key }); return; }
      var line = { id: id(option.variantId), label: (option.variantsByBedSize ? option.label + " — " + bedSpec.size : family.label + " " + option.label), quantity: choice.quantity * bedrooms, perBedroom: choice.quantity, unitPrice: found.price, price: found.price * choice.quantity * bedrooms, available: found.available, variant: found.variant, product: found.product, group: group.key, option: option };
      normalized[group.key] = { optionKey: option.key, quantity: choice.quantity };
      selected.push(line);
      contents.push(line);
    });
    if (errors.length) return result;
    if (new Set(contents.map(function (line) { return line.id; })).size !== contents.length) { errors.push({ code: "duplicate", label: "selected furniture" }); return result; }
    var baseProperties = properties(input.baseProperties);
    var standaloneItems = contents.map(function (line, index) {
      var item = { id: line.id, quantity: line.quantity };
      if (index === 0 && Object.keys(baseProperties).length) item.properties = Object.assign({}, baseProperties);
      if (index === 0 && input.sellingPlan) item.selling_plan = id(input.sellingPlan);
      return item;
    });
    var standaloneTotal = contents.reduce(function (sum, line) { return sum + line.price; }, 0);
    if (input.sellingPlan) {
      var allocation = (bed.variant.selling_plan_allocations || []).find(function (entry) { return id(entry.selling_plan_id) === id(input.sellingPlan); });
      if (!allocation || !price(allocation.price)) { errors.push({ code: "selling_plan", label: bed.label }); return result; }
      standaloneTotal += (allocation.price - bed.unitPrice) * bedrooms;
      bed.unitPrice = allocation.price;
      bed.price = allocation.price * bedrooms;
    }
    result.standaloneTotal = standaloneTotal;
    var standaloneAvailable = contents.every(function (line) { return line.available && validQuantity(line.variant, line.quantity); });
    if (standaloneAvailable) candidates.push({ total: standaloneTotal, items: standaloneItems, packageMatch: null });
    if (hasExtras && !input.sellingPlan) eligiblePackages(family, bed.id, normalized).forEach(function (pack) {
      var included = pack.selection || {};
      var found = identify(products, pack);
      if (!found || !found.available || !validQuantity(found.variant, bedrooms)) return;
      var remainder = [];
      selected.forEach(function (line) {
        var need = included[line.group];
        var quantity = (line.perBedroom - (need ? need.quantity : 0)) * bedrooms;
        if (quantity > 0) remainder.push({ line: line, quantity: quantity });
      });
      if (!remainder.every(function (entry) { return entry.line.available && validQuantity(entry.line.variant, entry.quantity); })) return;
      var includes = [bedSpec.size + " bed" + (bedSpec.finishLabel ? " — " + bedSpec.finishLabel : "")];
      family.groups.forEach(function (group) {
        var need = included[group.key];
        if (!need) return;
        var option = resolveOption(group.options.find(function (entry) { return entry.key === need.optionKey; }), bedSpec.size, bedSpec.variantId);
        if (option) includes.push(need.quantity + " × " + option.label);
      });
      var props = Object.assign({}, baseProperties, { Includes: includes.join("; ") });
      var items = [{ id: id(pack.variantId), quantity: bedrooms, properties: props }].concat(remainder.map(function (entry) { return { id: entry.line.id, quantity: entry.quantity }; }));
      var total = found.price * bedrooms + remainder.reduce(function (sum, entry) { return sum + entry.line.unitPrice * entry.quantity; }, 0);
      candidates.push({ total: total, items: items, packageMatch: Object.assign({}, pack, { includes: includes, unitPrice: found.price, label: family.label + " bedroom package" }) });
    });
    if (!candidates.length) {
      contents.forEach(function (line) {
        if (!line.available) errors.push({ code: line === bed ? "bed_unavailable" : "unavailable", label: line.label, group: line.group });
        else if (!validQuantity(line.variant, line.quantity)) errors.push({ code: "quantity", label: line.label, group: line.group });
      });
      if (!errors.length) errors.push({ code: "unavailable", label: "selected furniture" });
      return result;
    }
    candidates.sort(function (a, b) { return a.total - b.total; });
    var winner = candidates[0];
    result.ok = true;
    result.total = winner.total;
    result.items = winner.items;
    result.packageMatch = winner.packageMatch;
    result.savings = winner.packageMatch && standaloneAvailable ? Math.max(0, standaloneTotal - winner.total) : 0;
    return result;
  }
  return { version: 2, strings: strings, identify: identify, resolveOption: resolveOption, presetSelection: presetSelection, eligiblePackages: eligiblePackages, productHandles: productHandles, compute: compute, cloneSelection: cloneSelection, validQuantity: validQuantity, lineKey: lineKey, reconcile: reconcile };
});
